import * as fromDatatype from "../datatype-library";

export interface bl_cms_website_fi_label_list_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  cms_website_guid: fromDatatype.GuidDataFieldInterface;
  cms_country_guid: fromDatatype.GuidDataFieldInterface;
  fi_label_list_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  label_type: fromDatatype.VarcharDatatypeInterface;
  genre: fromDatatype.VarcharDatatypeInterface;
  group_type: fromDatatype.VarcharDatatypeInterface;
  sort_order: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_cms_website_fi_label_list_link_RowClass
  implements bl_cms_website_fi_label_list_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  cms_website_guid: fromDatatype.GuidDataFieldInterface;
  cms_country_guid: fromDatatype.GuidDataFieldInterface;
  fi_label_list_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  label_type: fromDatatype.VarcharDatatypeInterface;
  genre: fromDatatype.VarcharDatatypeInterface;
  group_type: fromDatatype.VarcharDatatypeInterface;
  sort_order: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
